goog.provide('el8.apphome.docMgr.main');

goog.require('el8.uiwidget.Panel');
goog.require('el8.apphome.docMgr.Organizer');
goog.require('el8.apphome.docMgr.Filer');
goog.require('el8.apphome.docMgr.Sorter');
goog.require('el8.apphome.docMgr.navMenu');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.app.pageLayout');

goog.require('el8.template.render.docMgr');
goog.require('el8.appshared.dialog.imagesZoom');
goog.require('el8.practicedata.base');
goog.require('el8.practicedata.uploadedImages');
goog.require('el8.practicedata.uploadedFiles');
goog.require('el8.practicedata.unfiledInboxes');


el8.apphome.docMgr.main = (function() {

    return {

        initNavMenu: function() {
            el8.apphome.docMgr.navMenu.init(this, $('#choose_document_manager_trigger'));
        },

        init: function() {

            if (this._isInit) { return; }

            var that = this;
            this._SORTER_WIDTH = 250;
            this._PANEL_LEFT_OFFSET = 50;
            this._PANEL_MINIMIZED_OFFSET = 0;

            /** Setting up the container **/
            this._panel = new el8.uiwidget.Panel({
                title: '', // No title
                width: function() { return el8.app.pageLayout.getAppWidth() - that._PANEL_LEFT_OFFSET; },
                height: function() { return el8.app.pageLayout.getAppInnerHeight(); },
                zIndex: 3,
                contentFn: el8.template.render.docMgr.content,
                offsets: {
                    'top': function() { return el8.app.pageLayout.getAppHeaderHeight(); },
                    'horizontal': function() { return that._PANEL_LEFT_OFFSET; }
                },
                minimizedOffsets: {
                    'top': function() { return el8.app.pageLayout.getAppHeaderHeight(); },
                    'horizontal': function() { return el8.app.pageLayout.getAppWidth() - that._PANEL_MINIMIZED_OFFSET; }
                },
                minimizeFn: function() {
                    if (that._organizer) { that._organizer.hide(); }
                }
            });

            el8.practicedata.uploadedImages.addRealtimeObserver(function(id, action) {
                that._realtimeUpdate.apply(that, ['UploadedImage', id, action]);
            });
            el8.practicedata.uploadedFiles.addRealtimeObserver(function(id, action) {
                that._realtimeUpdate.apply(that, ['UploadedFile', id, action]);
            });
            el8.practicedata.incomingFileGroups.addRealtimeObserver(function(id, action, extraData) {
                that._realtimeUpdate.apply(that, ['IncomingFileGroup', id, action, extraData]);
            });

            /* Do the initial display and sizing */
            this._panel.show();
            this._adjustSize();
            this._container = this._panel.getContentElt();
            this._container.on('dblclick', 'img.zoomable',  function(e) {
                var itemId = $(this).attr('data-id')*1;
                var item = el8.practicedata.uploadedImages.getById(itemId);
                el8.appshared.dialog.imagesZoom.show({
                    images: [item.getPrintUrl()]
                });
            });

            /** Setting up organizer, sorter, filer **/
            this._sorter = new el8.apphome.docMgr.Sorter({
                dialogContainer: this._panel.getContainer(),
                container: $('.sorter-section', this._container),
                panel: this._panel,
                dequeueItemFn: function(itemId) {
                    var item = el8.practicedata.getUploadedFileOrImage(itemId);
                    that._organizer.dequeueFileItem(item);
                    that._filer.removeItem(itemId);
                },
                queueItemFn: function(item) {
                    that._organizer.queueFileItem(item);
                },
                showFilerFn: function(itemIds) {
                    that._showFiler(itemIds);
                },
                resetFilerFn: function() {
                    that._filer._resetForms();
                },
                syncSelectImageFn: function(id) {
                    that._filer.scrollToPreviewItem(id);
                },
                updateFilerImages: function() {
                    that._filer.updatePreviewImages();
                }
            });
            this._organizer = new el8.apphome.docMgr.Organizer({
                dialogContainer: this._panel.getContainer(),
                container: $('.organizer-section', this._container),
                sorter: this._sorter,
                panel: this._panel,
                showFeedFn: function() {
                    that._clearNotifyNewDocument();
                }
            });
            this._filer = new el8.apphome.docMgr.Filer({
                dialogContainer: this._panel.getContainer(),
                panel: this._panel,
                container: $('.filer-section', this._container),
                showOrganizerFn: function() {
                    that._showOrganizer();
                },
                getFileIds: function() {
                    return that._sorter.getItemIds();
                },
                fileCallbackFn: function(itemIds) {
                    // Equivalent to being deleted, essentially
                    for (var i=0; i<itemIds.length; i++) {
                        var item = el8.practicedata.getUploadedFileOrImage(itemIds[i], true);
                        if (item) {
                            el8.practicedata.getEntitySet(item.getModelClass()).remove(item);
                        }
                        that._sorter.removeItem(itemIds[i]);
                        that._organizer.removeFileItem(itemIds[i]);
                        that._filer.removeItem(itemIds[i]);
                    }
                    el8.practicedata.unfiledInboxes.load();
                },
                updatePreviewedFn: function(id) {
                    that._sorter.forceSelect(id);
                }
            });

            this._bindTriggers();
            this._isSortListVisible = false;
            this._setSortListVisibility(true); // by default we show the list of doc thumbnails after init
            this._isInit = true;
        },

        show: function(inboxId) {
            if (!this._isInit) {
                this.init();
            } else {
                this._panel.show(true);
            }
            if (!this._isFilerShowing) {
                this._showOrganizer(inboxId);
            } else {
                this._showFiler();
            }
        },

        _setSortListVisibility: function (visible) {
            if (visible) {
                this._isSortListVisible = true;
                this._SORTER_WIDTH = 250;
                this._adjustSize();
                $('.sorter-content', this._container).removeClass('hidden');
                $('.toggle-queue-btn', this._container).text('Hide Queue');
            }
            else {
                this._isSortListVisible = false;
                this._SORTER_WIDTH = 0;
                this._adjustSize();
                $('.sorter-content', this._container).addClass('hidden');
                $('.toggle-queue-btn', this._container).text('Show Queue');
            }
        },

        _showOrganizer: function(inboxId) {
            this._setSortListVisibility(true); // when we switch between filer/organizer, we show the list of document thumbnails
            if (!this._isFilerShowing) {
                $('.docmgr-content', this._container).css('left', 0);
                this._updateHeaderActions(true);
                // Initial display, so be sure to show sorter
                this._sorter.show();
                this._filer.show();
                this._organizer.show(inboxId);
                this._isFilerShowing = false;
                this._sorter.setFilerMode(this._isFilerShowing);
                $('.sorter-content', this._container).removeClass('hidden');
            } else {
                var that = this;
                $('.docmgr-content', this._container).animate({
                    'left': 0
                }, {
                    'duration': 600,
                    'complete': function() {
                        that._updateHeaderActions(true);
                        that._organizer.show(inboxId);
                        that._isFilerShowing = false;
                        that._sorter.setFilerMode(that._isFilerShowing);
                        $('.sorter-content', this._container).removeClass('hidden');
                    }
                });
            }
            this._showNotifyNewDocument();
        },

        _showFiler: function(itemIds) {
            this._setSortListVisibility(true); // when we switch between filer/organizer, we show the list of document thumbnails
            if (!this._isFilerShowing) {
                var that = this;
                var leftShift = -1*$('.organizer-section', this._container).width();
                $('.docmgr-content', this._container).css('left', 0);
                $('.docmgr-content', this._container).animate({
                    'left': leftShift
                }, {
                    'duration': 600,
                    'complete': function() {
                        that._updateHeaderActions(false);
                        that._organizer.hide();
                        that._filer.show(itemIds);
                        that._isFilerShowing = true;
                        that._sorter.setFilerMode(that._isFilerShowing);
                    }
                });
            } else {
                this._updateHeaderActions(false);
                this._isFilerShowing = true;
                this._sorter.setFilerMode(this._isFilerShowing);
            }
            this._hideNotifyNewDocument();
        },

        _updateHeaderActions: function(isOrganizerShowing) {
            if (isOrganizerShowing) {
                $('.docmgr-actions-content', this._container).hide();
            } else {
                $('.docmgr-actions-content', this._container).show();
            }
        },

        _bindTriggers: function() {
            var that = this;
            this._container.on('click', '.show-organizer-trigger',  function(e) {
                that._showOrganizer();
            });
            this._container.on('click', '.toggle-queue-btn',  function(e) {
                that._setSortListVisibility(!that._isSortListVisible);
            });
            this._panel.bind('el8_adjustSize', function() {
                that._adjustSize();
            });
        },

        _adjustSize: function() {

            /**
             * Size each of the sections
             */
            var panelHeight = this._panel.getContentHeight();
            $(".organizer-section", this._container)
                .outerWidth(
                    this._panel.getContainer().width() - this._SORTER_WIDTH
                )
                .outerHeight(panelHeight);
            $(".sorter-section", this._container)
                .outerWidth(this._SORTER_WIDTH)
                .outerHeight(panelHeight);
            $(".filer-section", this._container)
                .outerWidth(
                    this._panel.getContainer().width() - this._SORTER_WIDTH
                )
                .outerHeight(panelHeight);

            /**
             * Size the doc mgr content external wrapper
             */
            $('.docmgr-content', this._container).outerWidth(
                2 * this._panel.getContainer().width()
                - $('.sorter-section', this._container).outerWidth(true)
            ).outerHeight(panelHeight);

            /**
             * If Filer mode, re-adjust the left margin
             */
            if (this._isFilerShowing) {
                var leftShift = -1*$('.organizer-section', this._container).width();
                $('.docmgr-content', this._container).css('left', leftShift);
            }
        },

        _notifyNewDocument: function(inboxId, fileGroupId) {
            if (!this._organizer) { return; }
            el8.practicedata.unfiledInboxes.thoughtfulLoad();
            this._organizer.updateFileGroupSuccess(inboxId, fileGroupId);
            this._organizer.markInboxStale(inboxId);
            if (el8.apphome.docMgr.util.isSameInbox(this._organizer._currFeedId, inboxId)) {
                if (this._notifyNewContainer) {
                    var currCount = $('.count-new', this._notifyNewContainer).text();
                    $('.count-new', this._notifyNewContainer).text(currCount*1 + 1);
                } else {
                    this._notifyNewContainer = $(el8.template.render.docMgr.notifyNew({count: 1}));
                    this._container.append(this._notifyNewContainer);
                    var that = this;
                    this._notifyNewContainer.on('click', 'button',  function(e) {
                        var action = $(this).attr('data-action');
                        if (action === 'refresh') {
                            that._organizer.refreshCurrent();
                            that._clearNotifyNewDocument();
                        }
                    });
                }
                if (this._isFilerShowing) {
                    this._hideNotifyNewDocument();
                } else {
                    this._showNotifyNewDocument();
                }
            }
        },

        _clearNotifyNewDocument: function() {
            if (this._notifyNewContainer) {
                this._notifyNewContainer.remove();
                this._notifyNewContainer = null;
            }
        },

        _hideNotifyNewDocument: function() {
            if (this._notifyNewContainer) { this._notifyNewContainer.hide(); }
        },

        _showNotifyNewDocument: function() {
            if (this._notifyNewContainer) { this._notifyNewContainer.show(); }
        },

        _realtimeUpdate: function(mClass, id, action, extraData) {
            switch(action) {
                case 'DELETED':
                    el8.practicedata.getEntitySet(mClass).remove(id);
                    this._sorter.removeItem(id);
                    this._organizer.removeFileItem(id);
                    this._filer.removeItem(id);
                    el8.practicedata.unfiledInboxes.thoughtfulLoad();
                    break;
                case 'UPDATED_IMAGE':
                    this._sorter.refreshImage(id);
                    this._organizer.refreshImageById(id);
                    this._filer.refreshImage(id);
                    break;
                case 'UPDATED':
                    var item = el8.practicedata.getEntitySet(mClass).refreshById(id);
                    if (!item) {
                        // File has been filed or removed; do exactly what we do when DELETED is called
                        this._realtimeUpdate(mClass, id, 'DELETED');
                    } else {
                        // This means file lock status changed; right now this only matters to organizer
                        this._organizer.refreshFileItem(item);
                    }
                    break;
                case 'CREATED':
                    var fileGroup = null, fileGroupId = null;
                    var item = el8.practicedata.getEntitySet(mClass).refreshById(id);
                    if (!item) { break; } // crazy but maybe somebody deleted immediately!

                    var inboxId = item.getPracticeFaxId() || 'manual';
                    if (mClass === 'IncomingFileGroup') {
                        fileGroup = item;
                        fileGroupId = id;
                    } else {
                        fileGroup = el8.practicedata.incomingFileGroups.refreshById(item.getFileGroupId());
                        fileGroupId = item.getFileGroupId();
                    }
                    this._notifyNewDocument(inboxId, fileGroupId);
                    break;
                case 'SCHEDULED':
                    if (mClass === 'IncomingFileGroup') {
                        var item = el8.practicedata.getEntitySet(mClass).refreshById(id);
                        if (!item) { break; }
                        var inboxId = item.getPracticeFaxId() || 'manual';
                        this._organizer.updateFileGroupProcessing(inboxId, id);
                    }
                    break;
                case 'PROCESSING':
                    if (mClass === 'IncomingFileGroup') {
                        var fileGroup = el8.practicedata.incomingFileGroups.getById(id, true); // fetch local only
                        if (fileGroup && extraData) {
                            var inboxId = fileGroup.getPracticeFaxId() || 'manual';
                            this._organizer.updateFileGroupProcessing(inboxId, id, extraData.progress);
                        }
                    }
                    break;
                case 'FAILED':
                    if (mClass === 'IncomingFileGroup') {
                        var fileGroup = el8.practicedata.incomingFileGroups.getById(id, true); // fetch local only
                        if (fileGroup) {
                            fileGroup.setProcessState('error');
                            var inboxId = fileGroup.getPracticeFaxId() || 'manual';
                            this._organizer.updateFileGroupError(inboxId, fileGroup);
                        }
                    }
                    break;
                default:
                    break;
            }
        }

    };

})();
